// import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { fetchAllDropdowns } from '../../store/slices/dropdownSlice';

// // ── Adjust these two import paths to match your project structure ──────────
// import {
//   GetPendingLeave,
//   GetApprovedLeave,
//   GetRejectedLeave,
//   GetCanceledLeave,
//   GetLeaveByUser,
//   ApproveLeave as ApproveLeaveAction,
// } from '../../action/Leave';
// import LeaveService from '../../services/LeaveService';
// // ─────────────────────────────────────────────────────────────────────────

// import {
//   Search, RefreshCw, CheckCircle, XCircle, Clock,
//   Calendar, User, FileText, ChevronDown, X, Eye,
//   AlertCircle, Loader2,
// } from 'lucide-react';

// // ─── Status — API returns the literal word (PENDING / APPROVED / REJECTED / CANCELLED) ─
// const STATUS_COLOR = {
//   PENDING:   { bg: 'bg-amber-50',   text: 'text-amber-700',   border: 'border-amber-200',   label: 'Pending' },
//   APPROVED:  { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200', label: 'Approved' },
//   REJECTED:  { bg: 'bg-red-50',     text: 'text-red-700',     border: 'border-red-200',     label: 'Rejected' },
//   CANCELLED: { bg: 'bg-slate-50',   text: 'text-slate-600',   border: 'border-slate-200',   label: 'Cancelled' },
//   CANCELED:  { bg: 'bg-slate-50',   text: 'text-slate-600',   border: 'border-slate-200',   label: 'Cancelled' },
// };
// const sc = (s) => STATUS_COLOR[(s || '').toUpperCase()] || STATUS_COLOR.PENDING;

// const TYPE_PALETTE = [
//   { bg: 'bg-blue-50', text: 'text-blue-700' },
//   { bg: 'bg-emerald-50', text: 'text-emerald-700' },
//   { bg: 'bg-purple-50', text: 'text-purple-700' },
//   { bg: 'bg-red-50', text: 'text-red-700' },
//   { bg: 'bg-amber-50', text: 'text-amber-700' },
//   { bg: 'bg-pink-50', text: 'text-pink-700' },
//   { bg: 'bg-cyan-50', text: 'text-cyan-700' },
//   { bg: 'bg-indigo-50', text: 'text-indigo-700' },
// ];
// const tc = (id) => TYPE_PALETTE[Math.abs(Number(id) || 0) % TYPE_PALETTE.length];

// // ─── Safe field getter — handles null / "null" / whitespace ───────────────
// const g = (leave, key) => {
//   const v = leave?.[key];
//   return (!v || v === 'null') ? '' : String(v).trim();
// };

// // ─── Real response fields, from GetAllRequestLeaveList ─────────────────────
// const getFormId    = (l) => g(l, 'HLF_FORM_ID');
// const getFormNo     = (l) => g(l, 'HLF_FORM_NO');
// const getServiceNo  = (l) => g(l, 'HLF_EMP_SERVICE_NO');
// const getTypeId      = (l) => g(l, 'HLF_LEAVE_TYPE_ID');
// const getFromDate    = (l) => g(l, 'HLF_FROM_DATE');
// const getToDate       = (l) => g(l, 'HLF_TO_DATE');
// const getTotalDays    = (l) => g(l, 'HLF_TOTAL_DAYS');
// const getIsHalfDay    = (l) => g(l, 'HLF_HALF_DAY');
// const getReason       = (l) => g(l, 'HLF_REASON');
// const getStatus       = (l) => g(l, 'HLF_STATUS');
// const isPendingLeave  = (l) => getStatus(l).toUpperCase() === 'PENDING';

// const fmtDate = (v) => {
//   if (!v) return '—';
//   try { return new Date(v).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }); }
//   catch { return String(v); }
// };

// const INP = "w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400 bg-gray-50 focus:bg-white transition-colors";
// const LBL = "block text-[11px] font-semibold text-gray-600 mb-1 uppercase tracking-wide";

// // ─── Status badge ─────────────────────────────────────────────────────────
// function StatusBadge({ status }) {
//   const s = sc(status);
//   const up = (status || '').toUpperCase();
//   return (
//     <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold border ${s.bg} ${s.text} ${s.border}`}>
//       {up === 'APPROVED' && <CheckCircle size={10} />}
//       {up === 'REJECTED' && <XCircle size={10} />}
//       {up === 'PENDING'  && <Clock size={10} />}
//       {s.label}
//     </span>
//   );
// }

// // ─── Leave card ─────────────────────────────────────────────────────────────
// function LeaveCard({ leave, leaveTypeMap, onApprove, onView, showApprove }) {
//   const typeId     = getTypeId(leave);
//   const typeName   = leaveTypeMap[typeId] || `Type #${typeId || '—'}`;
//   const t          = tc(typeId);
//   const status     = getStatus(leave);
//   const canApprove = showApprove && isPendingLeave(leave);

//   return (
//     <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow">
//       <div className="flex items-start justify-between mb-3">
//         <div className="flex items-center gap-2 flex-wrap">
//           <span className={`px-2 py-0.5 rounded-lg text-[11px] font-bold ${t.bg} ${t.text}`}>
//             {typeName}
//           </span>
//           <StatusBadge status={status} />
//         </div>
//         <span className="text-[11px] text-gray-400 font-mono shrink-0">#{getFormNo(leave)}</span>
//       </div>

//       <div className="grid grid-cols-2 gap-2 text-[12px] mb-3">
//         {getServiceNo(leave) && (
//           <div>
//             <p className="text-gray-400 text-[10px] uppercase font-semibold">Service No.</p>
//             <p className="text-gray-800 font-semibold">{getServiceNo(leave)}</p>
//           </div>
//         )}
//         <div>
//           <p className="text-gray-400 text-[10px] uppercase font-semibold">Duration</p>
//           <p className="text-gray-800 font-semibold">
//             {getTotalDays(leave) || '—'} day(s){getIsHalfDay(leave) === 'Y' ? ' · Half day' : ''}
//           </p>
//         </div>
//         <div>
//           <p className="text-gray-400 text-[10px] uppercase font-semibold">From</p>
//           <p className="text-gray-800">{fmtDate(getFromDate(leave))}</p>
//         </div>
//         <div>
//           <p className="text-gray-400 text-[10px] uppercase font-semibold">To</p>
//           <p className="text-gray-800">{fmtDate(getToDate(leave))}</p>
//         </div>
//       </div>

//       {getReason(leave) && (
//         <p className="text-[11px] text-gray-500 bg-gray-50 rounded-lg px-2.5 py-1.5 mb-3 border border-gray-100 line-clamp-2">
//           {getReason(leave)}
//         </p>
//       )}

//       <div className="flex gap-2 pt-2 border-t border-gray-100">
//         <button onClick={() => onView(leave)}
//           className="flex items-center gap-1 px-2.5 py-1.5 text-[11px] font-medium text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
//           <Eye size={11} /> View
//         </button>
//         {canApprove && (
//           <button onClick={() => onApprove(leave)}
//             className="flex-1 flex items-center justify-center gap-1 px-2.5 py-1.5 text-[11px] font-semibold text-white bg-emerald-500 hover:bg-emerald-600 rounded-lg transition-colors">
//             <CheckCircle size={11} /> Approve
//           </button>
//         )}
//       </div>
//     </div>
//   );
// }

// // ─── Employee search dropdown (unchanged logic, still driven by Redux employees) ─
// function EmpSearch({ value, onChange, employees, placeholder = 'Search employee...' }) {
//   const [q, setQ] = useState('');
//   const [open, setOpen] = useState(false);
//   const ref = useRef();

//   const fmt = (v) => (!v || v === 'null') ? '' : String(v).trim();

//   const filtered = useMemo(() => {
//     if (!q) return employees.slice(0, 20);
//     const lq = q.toLowerCase();
//     return employees.filter(e =>
//       fmt(e.p_ced_service_no).includes(lq) ||
//       `${fmt(e.p_first_name)} ${fmt(e.p_last_name)}`.toLowerCase().includes(lq) ||
//       fmt(e.p_report_name).toLowerCase().includes(lq)
//     ).slice(0, 20);
//   }, [employees, q]);

//   const selected = employees.find(e => fmt(e.p_ced_service_no) === value);
//   const displayName = selected
//     ? `${fmt(selected.p_ced_service_no)} — ${fmt(selected.p_report_name) || `${fmt(selected.p_first_name)} ${fmt(selected.p_last_name)}`}`
//     : '';

//   useEffect(() => {
//     const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
//     document.addEventListener('mousedown', handler);
//     return () => document.removeEventListener('mousedown', handler);
//   }, []);

//   return (
//     <div ref={ref} className="relative">
//       <div className={`${INP} flex items-center gap-2 cursor-pointer`} onClick={() => setOpen(v => !v)}>
//         <User size={13} className="text-gray-400 shrink-0" />
//         <span className={`flex-1 text-sm truncate ${value ? 'text-gray-800' : 'text-gray-400'}`}>
//           {value ? displayName : placeholder}
//         </span>
//         <ChevronDown size={12} className={`text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} />
//       </div>
//       {open && (
//         <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-xl shadow-xl z-50">
//           <div className="p-2 border-b border-gray-100">
//             <div className="relative">
//               <Search size={12} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" />
//               <input autoFocus value={q} onChange={e => setQ(e.target.value)}
//                 placeholder="Name or service no..."
//                 className="w-full pl-7 pr-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary-300" />
//             </div>
//           </div>
//           <div className="max-h-52 overflow-y-auto py-1">
//             {filtered.length === 0
//               ? <p className="text-center text-[12px] text-gray-400 py-3">No results</p>
//               : filtered.map(e => {
//                 const sno = fmt(e.p_ced_service_no);
//                 const name = fmt(e.p_report_name) || `${fmt(e.p_first_name)} ${fmt(e.p_last_name)}`.trim();
//                 return (
//                   <button key={sno} onClick={() => { onChange(sno, e); setOpen(false); setQ(''); }}
//                     className={`w-full flex items-center gap-2.5 px-3 py-2 hover:bg-primary-50 transition-colors text-left
//                         ${value === sno ? 'bg-primary-50 text-primary-700' : ''}`}>
//                     <span className="text-[11px] font-mono text-gray-400 w-16 shrink-0">{sno}</span>
//                     <span className="text-[12px] text-gray-800 truncate">{name}</span>
//                   </button>
//                 );
//               })}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

// // ─── View Leave Detail Modal ─────────────────────────────────────────────────
// function ViewLeaveModal({ leave, leaveTypeMap, onClose, onApprove }) {
//   if (!leave) return null;
//   const canApprove = isPendingLeave(leave);
//   const typeId = getTypeId(leave);

//   const rows = [
//     ['Form No.',        getFormNo(leave)],
//     ['Service No.',      getServiceNo(leave)],
//     ['Leave Type',        leaveTypeMap[typeId] || `Type #${typeId || '—'}`],
//     ['Total Days',         getTotalDays(leave) ? `${getTotalDays(leave)} day(s)` : ''],
//     ['Half Day',            g(leave, 'HLF_HALF_DAY') === 'Y' ? `Yes (${g(leave, 'HLF_HALF_DAY_TYPE') || '—'})` : 'No'],
//     ['From Date',            fmtDate(getFromDate(leave))],
//     ['To Date',               fmtDate(getToDate(leave))],
//     ['Applied Date',           fmtDate(g(leave, 'HLF_APPLIED_DATE'))],
//     ['Contact No.',             g(leave, 'HLF_CONTACT_NO')],
//     ['Reason',                   getReason(leave)],
//     ['Status',                    sc(getStatus(leave)).label],
//     ['Approved By',                 g(leave, 'HLF_APPROVED_BY')],
//     ['Approved Date',                g(leave, 'HLF_APPROVED_DATE') ? fmtDate(g(leave, 'HLF_APPROVED_DATE')) : ''],
//     ['Reject Reason',                 g(leave, 'HLF_REJECT_REASON')],
//     ['Attachment',                     g(leave, 'HLF_ATTACHMENT_PATH')],
//   ];

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
//       <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[85vh] flex flex-col">
//         <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 bg-gradient-to-r from-slate-700 to-slate-800 rounded-t-2xl shrink-0">
//           <div className="flex items-center gap-2">
//             <FileText size={16} className="text-white" />
//             <h2 className="text-white font-bold text-sm">Leave Details — #{getFormNo(leave)}</h2>
//           </div>
//           <button onClick={onClose} className="text-white/70 hover:text-white p-1 rounded-lg hover:bg-white/10">
//             <X size={16} />
//           </button>
//         </div>
//         <div className="overflow-y-auto flex-1 p-5">
//           {rows.map(([label, val]) => val ? (
//             <div key={label} className="flex items-start gap-2 py-2 border-b border-gray-50 last:border-0">
//               <span className="text-[11px] text-gray-500 w-36 shrink-0 font-medium">{label}</span>
//               <span className="text-[12px] text-gray-800 flex-1 break-words">{val}</span>
//             </div>
//           ) : null)}
//         </div>
//         <div className="flex gap-2 px-5 py-3 border-t border-gray-200 bg-gray-50 rounded-b-2xl shrink-0">
//           <button onClick={onClose}
//             className="px-4 py-2 text-sm font-medium text-gray-600 border border-gray-200 rounded-xl hover:bg-gray-100">
//             Close
//           </button>
//           {canApprove && (
//             <button onClick={() => { onApprove(leave); onClose(); }}
//               className="flex-1 flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-bold text-white bg-emerald-500 hover:bg-emerald-600 rounded-xl transition-colors">
//               <CheckCircle size={14} /> Approve This Leave
//             </button>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ─── Approve Confirm Modal — now goes through leaveActions.ApproveLeave ──────
// function ApproveModal({ leave, currentUserId, onClose, onSuccess }) {
//   const dispatch = useDispatch();
//   const [reason, setReason] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');

//   const formId = getFormId(leave);
//   const formNo = getFormNo(leave);

//   const handleApprove = async () => {
//     if (!formId || !formNo) return setError('Leave form id/no missing');
//     setLoading(true); setError('');
//     try {
//       // ApproveLeave(LeaveFormId, FormNo, UserId, Reason) — dispatched from leaveActions.js
//       await dispatch(ApproveLeaveAction(formId, formNo, currentUserId, reason));
//       onSuccess?.('Leave approved successfully!');
//       onClose();
//     } catch (e) {
//       setError(typeof e === 'string' ? e : (e?.message || 'Approval failed'));
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
//       <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm">
//         <div className="flex items-center gap-2 px-5 py-4 border-b border-gray-200 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-t-2xl">
//           <CheckCircle size={16} className="text-white" />
//           <h2 className="text-white font-bold text-sm">Approve Leave</h2>
//         </div>
//         <div className="p-5 space-y-3">
//           <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-3 space-y-1.5">
//             <div className="flex justify-between text-[12px]">
//               <span className="text-emerald-700 font-semibold">Form No.</span>
//               <span className="text-emerald-900 font-bold">#{formNo}</span>
//             </div>
//             <div className="flex justify-between text-[12px]">
//               <span className="text-emerald-700 font-semibold">Duration</span>
//               <span className="text-emerald-900">
//                 {getTotalDays(leave)} day(s) · {fmtDate(getFromDate(leave))} → {fmtDate(getToDate(leave))}
//               </span>
//             </div>
//             <div className="flex justify-between text-[12px]">
//               <span className="text-emerald-700 font-semibold">Reason</span>
//               <span className="text-emerald-900 text-right max-w-[60%]">{getReason(leave) || '—'}</span>
//             </div>
//           </div>

//           {error && (
//             <div className="text-[12px] text-red-600 bg-red-50 px-3 py-2 rounded-lg border border-red-200 flex gap-1.5 items-center">
//               <AlertCircle size={12} />{error}
//             </div>
//           )}

//           <div>
//             <label className={LBL}>Approval Note (optional)</label>
//             <input className={INP} placeholder="Reason / remarks"
//               value={reason} onChange={e => setReason(e.target.value)} />
//           </div>
//         </div>
//         <div className="flex gap-2 px-5 py-4 border-t border-gray-200 bg-gray-50 rounded-b-2xl">
//           <button onClick={onClose}
//             className="px-4 py-2 text-sm font-medium text-gray-600 border border-gray-200 rounded-xl hover:bg-gray-100">
//             Cancel
//           </button>
//           <button onClick={handleApprove} disabled={loading}
//             className="flex-1 flex items-center justify-center gap-1.5 py-2 text-sm font-bold text-white bg-emerald-500 hover:bg-emerald-600 rounded-xl disabled:opacity-60">
//             {loading ? <><Loader2 size={13} className="animate-spin" />Approving...</> : <><CheckCircle size={13} />Confirm Approve</>}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ═══════════════════════════════════════════════════════════════════════════
// // Main Page
// // ═══════════════════════════════════════════════════════════════════════════
// export default function LeaveManagement() {
//   const dispatch = useDispatch();
//   const { employees } = useSelector(s => s.employees);
//   const dropdowns = useSelector(s => s.dropdowns || {});
//   // TODO: point this at wherever your logged-in user id actually lives
//   const currentUserId = useSelector(s => s.auth?.user?.userId || s.auth?.user?.UserId || '');

//   useEffect(() => {
//     if (!dropdowns.loaded && !dropdowns.loading) {
//       dispatch(fetchAllDropdowns());
//     }
//   }, [dispatch, dropdowns.loaded, dropdowns.loading]);

//   // ── Leave type id -> name map, loaded once from LeaveService.GetLeaveTypeList ──
//   const [leaveTypeMap, setLeaveTypeMap] = useState({});
//   useEffect(() => {
//     let cancelled = false;
//     LeaveService.GetLeaveTypeList()
//       .then(res => {
//         const rows = res?.data?.ResultSet || res?.data?.resultSet || [];
//         const map = {};
//         rows.forEach(r => {
//           const id = r.TYPE_ID ?? r.TypeId ?? r.typeId ?? r.p_typeId;
//           const name = r.TYPE_NAME ?? r.TypeName ?? r.typeName ?? r.p_typeName;
//           if (id != null) map[String(id)] = name;
//         });
//         if (!cancelled) setLeaveTypeMap(map);
//       })
//       .catch(() => { /* leave type names are cosmetic — fail silently */ });
//     return () => { cancelled = true; };
//   }, []);

//   const [tab, setTab] = useState('pending');
//   const [leaves, setLeaves] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [toast, setToast] = useState('');
//   const [searchSno, setSearchSno] = useState('');
//   const [searchLoading, setSearchLoading] = useState(false);
//   const [viewLeave, setViewLeave] = useState(null);
//   const [approveLeave, setApproveLeave] = useState(null);

//   const showToast = useCallback((msg) => {
//     setToast(msg);
//     setTimeout(() => setToast(''), 3500);
//   }, []);

//   // ── All data now flows through leaveActions.js -> LeaveService.js ─────────
//   const runFetch = useCallback((thunk, { search = false } = {}) => {
//     (search ? setSearchLoading : setLoading)(true);
//     setError('');
//     dispatch(thunk)
//       .then(data => setLeaves(Array.isArray(data) ? data : []))
//       .catch(e => setError(typeof e === 'string' ? e : (e?.message || 'Failed to load leaves')))
//       .finally(() => (search ? setSearchLoading : setLoading)(false));
//   }, [dispatch]);

//   const fetchByTab = useCallback((t) => {
//     if (t === 'pending')  return runFetch(GetPendingLeave());
//     if (t === 'approved') return runFetch(GetApprovedLeave());
//     if (t === 'rejected') return runFetch(GetRejectedLeave());
//     if (t === 'canceled') return runFetch(GetCanceledLeave());
//   }, [runFetch]);

//   const fetchByEmployee = useCallback((sno) => {
//     if (!sno) return;
//     runFetch(GetLeaveByUser(sno), { search: true });
//   }, [runFetch]);

//   useEffect(() => {
//     if (tab !== 'search') fetchByTab(tab);
//   }, [tab, fetchByTab]);

//   useEffect(() => {
//     if (tab === 'search' && searchSno) fetchByEmployee(searchSno);
//   }, [tab, searchSno, fetchByEmployee]);

//   const stats = useMemo(() => ({
//     total:    leaves.length,
//     pending:  leaves.filter(isPendingLeave).length,
//     approved: leaves.filter(l => getStatus(l).toUpperCase() === 'APPROVED').length,
//   }), [leaves]);

//   const TABS = [
//     { id: 'pending',  label: 'Pending' },
//     { id: 'approved', label: 'Approved' },
//     { id: 'rejected', label: 'Rejected' },
//     { id: 'canceled', label: 'Canceled' },
//   ];

//   return (
//     <div className="flex flex-col h-full bg-gray-50 overflow-hidden">
//       {toast && (
//         <div className="fixed top-4 right-4 z-[100] flex items-center gap-2 px-4 py-3 bg-emerald-500 text-white rounded-xl shadow-lg text-sm font-medium">
//           <CheckCircle size={15} />{toast}
//         </div>
//       )}

//       {/* Header */}
//       <div className="bg-white border-b border-gray-200 px-6 py-4 shrink-0">
//         <div className="flex items-center justify-between flex-wrap gap-3">
//           <div className="flex items-center gap-3">
//             <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-600 rounded-xl flex items-center justify-center shadow-sm">
//               <Calendar size={18} className="text-white" />
//             </div>
//             <div>
//               <h1 className="text-base font-bold text-gray-900">Leave Management</h1>
//               <p className="text-[11px] text-gray-500">
//                 {leaves.length > 0 ? `${leaves.length} records loaded` : 'eHRM Leave Management'}
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Tabs */}
//         <div className="flex gap-1 mt-4 flex-wrap">
//           {TABS.map(t => (
//             <button key={t.id} onClick={() => setTab(t.id)}
//               className={`px-3 py-1.5 rounded-lg text-[12px] font-semibold transition-colors
//                 ${tab === t.id ? 'bg-primary-500 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
//               {t.label}
//             </button>
//           ))}
//         </div>

//         {leaves.length > 0 && (
//           <div className="flex gap-3 mt-4 flex-wrap">
//             {[
//               { label: 'Total',    value: stats.total,    color: 'text-gray-800' },
//               { label: 'Pending',  value: stats.pending,  color: 'text-amber-600' },
//               { label: 'Approved', value: stats.approved, color: 'text-emerald-600' },
//             ].map(({ label, value, color }) => (
//               <div key={label} className="bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 flex items-center gap-2">
//                 <span className={`text-xl font-extrabold ${color}`}>{value}</span>
//                 <span className="text-[11px] text-gray-500 font-medium">{label}</span>
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       {/* Content */}
//       <div className="flex-1 overflow-y-auto px-6 py-5">
        

//         {tab !== 'search' && (
//           <div className="mb-5 flex justify-end">
//             <button onClick={() => fetchByTab(tab)} disabled={loading}
//               className="flex items-center gap-1.5 px-3 py-2 border border-gray-200 rounded-xl text-sm text-gray-600 hover:bg-gray-50 transition-colors">
//               <RefreshCw size={12} className={loading ? 'animate-spin' : ''} /> Refresh
//             </button>
//           </div>
//         )}

//         {error && (
//           <div className="flex items-center gap-2 px-4 py-3 bg-red-50 border border-red-200 rounded-xl text-red-700 text-sm mb-4">
//             <AlertCircle size={14} />{error}
//             <button onClick={() => setError('')} className="ml-auto"><X size={13} /></button>
//           </div>
//         )}

//         {(loading || searchLoading) && (
//           <div className="flex items-center justify-center py-16 gap-3 text-gray-400">
//             <Loader2 size={22} className="animate-spin text-primary-500" />
//             <span className="text-sm">Loading leaves...</span>
//           </div>
//         )}

//         {!loading && !searchLoading && leaves.length === 0 && !error && (
//           <div className="flex flex-col items-center justify-center py-16 gap-3 text-gray-400">
//             <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center">
//               <Calendar size={28} className="opacity-40" />
//             </div>
//             <p className="text-sm font-semibold text-gray-500">
//               {tab === 'search' && !searchSno ? 'Select an employee above to load leaves' : 'No leave requests found'}
//             </p>
//           </div>
//         )}

//         {!loading && !searchLoading && leaves.length > 0 && (
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
//             {leaves.map((leave, i) => (
//               <LeaveCard
//                 key={getFormId(leave) || getFormNo(leave) || i}
//                 leave={leave}
//                 leaveTypeMap={leaveTypeMap}
//                 onView={setViewLeave}
//                 onApprove={setApproveLeave}
//                 showApprove
//               />
//             ))}
//           </div>
//         )}
//       </div>

//       {viewLeave && (
//         <ViewLeaveModal
//           leave={viewLeave}
//           leaveTypeMap={leaveTypeMap}
//           onClose={() => setViewLeave(null)}
//           onApprove={(l) => { setViewLeave(null); setApproveLeave(l); }}
//         />
//       )}
//       {approveLeave && (
//         <ApproveModal
//           leave={approveLeave}
//           currentUserId={currentUserId}
//           onClose={() => setApproveLeave(null)}
//           onSuccess={(msg) => {
//             showToast(msg);
//             tab === 'search' && searchSno ? fetchByEmployee(searchSno) : fetchByTab(tab);
//           }}
//         />
//       )}
//     </div>
//   );
// }



import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAllDropdowns } from '../../store/slices/dropdownSlice';

/* Leave data comes from store/slices/leaveSlice. The thunk is aliased because
   this file already has a local `approveLeave` state variable. */
import {
  fetchLeaveRequestsByStatus,
  fetchLeaveDetailsByUser,
  approveLeave as approveLeaveThunk,
} from '../../store/slices/leaveSlice';
import {
  PENDING_LEAVE_STATUS,
  APPROVED_LEAVE_STATUS,
  REJECT_LEAVE_STATUS,
  CANCEL_LEAVE_STATUS,
} from '../../constants/leaveConstent';
import LeaveService from '../../services/LeaveService';
// ─────────────────────────────────────────────────────────────────────────

import {
  Search, RefreshCw, CheckCircle, XCircle, Clock,
  Calendar, User, FileText, ChevronDown, X, Eye,
  AlertCircle, Loader2,
} from 'lucide-react';

// ─── Status — API returns the literal word (PENDING / APPROVED / REJECTED / CANCELLED) ─
const STATUS_COLOR = {
  PENDING:   { bg: 'bg-amber-50',   text: 'text-amber-700',   border: 'border-amber-200',   label: 'Pending' },
  APPROVED:  { bg: 'bg-emerald-50', text: 'text-emerald-700', border: 'border-emerald-200', label: 'Approved' },
  REJECTED:  { bg: 'bg-red-50',     text: 'text-red-700',     border: 'border-red-200',     label: 'Rejected' },
  CANCELLED: { bg: 'bg-slate-50',   text: 'text-slate-600',   border: 'border-slate-200',   label: 'Cancelled' },
  CANCELED:  { bg: 'bg-slate-50',   text: 'text-slate-600',   border: 'border-slate-200',   label: 'Cancelled' },
};
const sc = (s) => STATUS_COLOR[(s || '').toUpperCase()] || STATUS_COLOR.PENDING;

const TYPE_PALETTE = [
  { bg: 'bg-blue-50', text: 'text-blue-700' },
  { bg: 'bg-emerald-50', text: 'text-emerald-700' },
  { bg: 'bg-purple-50', text: 'text-purple-700' },
  { bg: 'bg-red-50', text: 'text-red-700' },
  { bg: 'bg-amber-50', text: 'text-amber-700' },
  { bg: 'bg-pink-50', text: 'text-pink-700' },
  { bg: 'bg-cyan-50', text: 'text-cyan-700' },
  { bg: 'bg-indigo-50', text: 'text-indigo-700' },
];
const tc = (id) => TYPE_PALETTE[Math.abs(Number(id) || 0) % TYPE_PALETTE.length];

// ─── Safe field getter — handles null / "null" / whitespace ───────────────
const g = (leave, key) => {
  const v = leave?.[key];
  return (!v || v === 'null') ? '' : String(v).trim();
};

// ─── Real response fields, from GetAllRequestLeaveList ─────────────────────
const getFormId    = (l) => g(l, 'HLF_FORM_ID');
const getFormNo     = (l) => g(l, 'HLF_FORM_NO');
const getServiceNo  = (l) => g(l, 'HLF_EMP_SERVICE_NO');
const getTypeId      = (l) => g(l, 'HLF_LEAVE_TYPE_ID');
const getFromDate    = (l) => g(l, 'HLF_FROM_DATE');
const getToDate       = (l) => g(l, 'HLF_TO_DATE');
const getTotalDays    = (l) => g(l, 'HLF_TOTAL_DAYS');
const getIsHalfDay    = (l) => g(l, 'HLF_HALF_DAY');
const getReason       = (l) => g(l, 'HLF_REASON');
const getStatus       = (l) => g(l, 'HLF_STATUS');
const isPendingLeave  = (l) => getStatus(l).toUpperCase() === 'PENDING';

const fmtDate = (v) => {
  if (!v) return '—';
  try { return new Date(v).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' }); }
  catch { return String(v); }
};

const INP = "w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary-300 focus:border-primary-400 bg-gray-50 focus:bg-white transition-colors";
const LBL = "block text-[11px] font-semibold text-gray-600 mb-1 uppercase tracking-wide";

// ─── Status badge ─────────────────────────────────────────────────────────
function StatusBadge({ status }) {
  const s = sc(status);
  const up = (status || '').toUpperCase();
  return (
    <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-semibold border ${s.bg} ${s.text} ${s.border}`}>
      {up === 'APPROVED' && <CheckCircle size={10} />}
      {up === 'REJECTED' && <XCircle size={10} />}
      {up === 'PENDING'  && <Clock size={10} />}
      {s.label}
    </span>
  );
}

// ─── Leave card ─────────────────────────────────────────────────────────────
function LeaveCard({ leave, leaveTypeMap, onApprove, onView, showApprove }) {
  const typeId     = getTypeId(leave);
  const typeName   = leaveTypeMap[typeId] || `Type #${typeId || '—'}`;
  const t          = tc(typeId);
  const status     = getStatus(leave);
  const canApprove = showApprove && isPendingLeave(leave);

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center gap-2 flex-wrap">
          <span className={`px-2 py-0.5 rounded-lg text-[11px] font-bold ${t.bg} ${t.text}`}>
            {typeName}
          </span>
          <StatusBadge status={status} />
        </div>
        <span className="text-[11px] text-gray-400 font-mono shrink-0">#{getFormNo(leave)}</span>
      </div>

      <div className="grid grid-cols-2 gap-2 text-[12px] mb-3">
        {getServiceNo(leave) && (
          <div>
            <p className="text-gray-400 text-[10px] uppercase font-semibold">Service No.</p>
            <p className="text-gray-800 font-semibold">{getServiceNo(leave)}</p>
          </div>
        )}
        <div>
          <p className="text-gray-400 text-[10px] uppercase font-semibold">Duration</p>
          <p className="text-gray-800 font-semibold">
            {getTotalDays(leave) || '—'} day(s){getIsHalfDay(leave) === 'Y' ? ' · Half day' : ''}
          </p>
        </div>
        <div>
          <p className="text-gray-400 text-[10px] uppercase font-semibold">From</p>
          <p className="text-gray-800">{fmtDate(getFromDate(leave))}</p>
        </div>
        <div>
          <p className="text-gray-400 text-[10px] uppercase font-semibold">To</p>
          <p className="text-gray-800">{fmtDate(getToDate(leave))}</p>
        </div>
      </div>

      {getReason(leave) && (
        <p className="text-[11px] text-gray-500 bg-gray-50 rounded-lg px-2.5 py-1.5 mb-3 border border-gray-100 line-clamp-2">
          {getReason(leave)}
        </p>
      )}

      <div className="flex gap-2 pt-2 border-t border-gray-100">
        <button onClick={() => onView(leave)}
          className="flex items-center gap-1 px-2.5 py-1.5 text-[11px] font-medium text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors">
          <Eye size={11} /> View
        </button>
        {canApprove && (
          <button onClick={() => onApprove(leave)}
            className="flex-1 flex items-center justify-center gap-1 px-2.5 py-1.5 text-[11px] font-semibold text-white bg-emerald-500 hover:bg-emerald-600 rounded-lg transition-colors">
            <CheckCircle size={11} /> Approve
          </button>
        )}
      </div>
    </div>
  );
}

// ─── Employee search dropdown (unchanged logic, still driven by Redux employees) ─
function EmpSearch({ value, onChange, employees, placeholder = 'Search employee...' }) {
  const [q, setQ] = useState('');
  const [open, setOpen] = useState(false);
  const ref = useRef();

  const fmt = (v) => (!v || v === 'null') ? '' : String(v).trim();

  const filtered = useMemo(() => {
    if (!q) return employees.slice(0, 20);
    const lq = q.toLowerCase();
    return employees.filter(e =>
      fmt(e.p_ced_service_no).includes(lq) ||
      `${fmt(e.p_first_name)} ${fmt(e.p_last_name)}`.toLowerCase().includes(lq) ||
      fmt(e.p_report_name).toLowerCase().includes(lq)
    ).slice(0, 20);
  }, [employees, q]);

  const selected = employees.find(e => fmt(e.p_ced_service_no) === value);
  const displayName = selected
    ? `${fmt(selected.p_ced_service_no)} — ${fmt(selected.p_report_name) || `${fmt(selected.p_first_name)} ${fmt(selected.p_last_name)}`}`
    : '';

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  return (
    <div ref={ref} className="relative">
      <div className={`${INP} flex items-center gap-2 cursor-pointer`} onClick={() => setOpen(v => !v)}>
        <User size={13} className="text-gray-400 shrink-0" />
        <span className={`flex-1 text-sm truncate ${value ? 'text-gray-800' : 'text-gray-400'}`}>
          {value ? displayName : placeholder}
        </span>
        <ChevronDown size={12} className={`text-gray-400 transition-transform ${open ? 'rotate-180' : ''}`} />
      </div>
      {open && (
        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-200 rounded-xl shadow-xl z-50">
          <div className="p-2 border-b border-gray-100">
            <div className="relative">
              <Search size={12} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400" />
              <input autoFocus value={q} onChange={e => setQ(e.target.value)}
                placeholder="Name or service no..."
                className="w-full pl-7 pr-3 py-1.5 text-sm border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-primary-300" />
            </div>
          </div>
          <div className="max-h-52 overflow-y-auto py-1">
            {filtered.length === 0
              ? <p className="text-center text-[12px] text-gray-400 py-3">No results</p>
              : filtered.map(e => {
                const sno = fmt(e.p_ced_service_no);
                const name = fmt(e.p_report_name) || `${fmt(e.p_first_name)} ${fmt(e.p_last_name)}`.trim();
                return (
                  <button key={sno} onClick={() => { onChange(sno, e); setOpen(false); setQ(''); }}
                    className={`w-full flex items-center gap-2.5 px-3 py-2 hover:bg-primary-50 transition-colors text-left
                        ${value === sno ? 'bg-primary-50 text-primary-700' : ''}`}>
                    <span className="text-[11px] font-mono text-gray-400 w-16 shrink-0">{sno}</span>
                    <span className="text-[12px] text-gray-800 truncate">{name}</span>
                  </button>
                );
              })}
          </div>
        </div>
      )}
    </div>
  );
}

// ─── View Leave Detail Modal ─────────────────────────────────────────────────
function ViewLeaveModal({ leave, leaveTypeMap, onClose, onApprove }) {
  if (!leave) return null;
  const canApprove = isPendingLeave(leave);
  const typeId = getTypeId(leave);

  const rows = [
    ['Form No.',        getFormNo(leave)],
    ['Service No.',      getServiceNo(leave)],
    ['Leave Type',        leaveTypeMap[typeId] || `Type #${typeId || '—'}`],
    ['Total Days',         getTotalDays(leave) ? `${getTotalDays(leave)} day(s)` : ''],
    ['Half Day',            g(leave, 'HLF_HALF_DAY') === 'Y' ? `Yes (${g(leave, 'HLF_HALF_DAY_TYPE') || '—'})` : 'No'],
    ['From Date',            fmtDate(getFromDate(leave))],
    ['To Date',               fmtDate(getToDate(leave))],
    ['Applied Date',           fmtDate(g(leave, 'HLF_APPLIED_DATE'))],
    ['Contact No.',             g(leave, 'HLF_CONTACT_NO')],
    ['Reason',                   getReason(leave)],
    ['Status',                    sc(getStatus(leave)).label],
    ['Approved By',                 g(leave, 'HLF_APPROVED_BY')],
    ['Approved Date',                g(leave, 'HLF_APPROVED_DATE') ? fmtDate(g(leave, 'HLF_APPROVED_DATE')) : ''],
    ['Reject Reason',                 g(leave, 'HLF_REJECT_REASON')],
    ['Attachment',                     g(leave, 'HLF_ATTACHMENT_PATH')],
  ];

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md max-h-[85vh] flex flex-col">
        <div className="flex items-center justify-between px-5 py-4 border-b border-gray-200 bg-gradient-to-r from-slate-700 to-slate-800 rounded-t-2xl shrink-0">
          <div className="flex items-center gap-2">
            <FileText size={16} className="text-white" />
            <h2 className="text-white font-bold text-sm">Leave Details — #{getFormNo(leave)}</h2>
          </div>
          <button onClick={onClose} className="text-white/70 hover:text-white p-1 rounded-lg hover:bg-white/10">
            <X size={16} />
          </button>
        </div>
        <div className="overflow-y-auto flex-1 p-5">
          {rows.map(([label, val]) => val ? (
            <div key={label} className="flex items-start gap-2 py-2 border-b border-gray-50 last:border-0">
              <span className="text-[11px] text-gray-500 w-36 shrink-0 font-medium">{label}</span>
              <span className="text-[12px] text-gray-800 flex-1 break-words">{val}</span>
            </div>
          ) : null)}
        </div>
        <div className="flex gap-2 px-5 py-3 border-t border-gray-200 bg-gray-50 rounded-b-2xl shrink-0">
          <button onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-600 border border-gray-200 rounded-xl hover:bg-gray-100">
            Close
          </button>
          {canApprove && (
            <button onClick={() => { onApprove(leave); onClose(); }}
              className="flex-1 flex items-center justify-center gap-1.5 px-4 py-2 text-sm font-bold text-white bg-emerald-500 hover:bg-emerald-600 rounded-xl transition-colors">
              <CheckCircle size={14} /> Approve This Leave
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

// ─── Approve Confirm Modal — now goes through leaveActions.ApproveLeave ──────
function ApproveModal({ leave, currentUserId, onClose, onSuccess }) {
  const dispatch = useDispatch();
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const formId = getFormId(leave);
  const formNo = getFormNo(leave);

  const handleApprove = async () => {
    if (!formId || !formNo) return setError('Leave form id/no missing');
    setLoading(true); setError('');
    try {
      // unwrap() so a rejected thunk throws into the catch below, the way the
      // old action's rejected promise did.
      await dispatch(approveLeaveThunk({
        LeaveFormId: formId,
        FormNo: formNo,
        UserId: currentUserId,
        Reason: reason,
      })).unwrap();
      onSuccess?.('Leave approved successfully!');
      onClose();
    } catch (e) {
      setError(typeof e === 'string' ? e : (e?.message || 'Approval failed'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm">
        <div className="flex items-center gap-2 px-5 py-4 border-b border-gray-200 bg-gradient-to-r from-emerald-500 to-emerald-600 rounded-t-2xl">
          <CheckCircle size={16} className="text-white" />
          <h2 className="text-white font-bold text-sm">Approve Leave</h2>
        </div>
        <div className="p-5 space-y-3">
          <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-3 space-y-1.5">
            <div className="flex justify-between text-[12px]">
              <span className="text-emerald-700 font-semibold">Form No.</span>
              <span className="text-emerald-900 font-bold">#{formNo}</span>
            </div>
            <div className="flex justify-between text-[12px]">
              <span className="text-emerald-700 font-semibold">Duration</span>
              <span className="text-emerald-900">
                {getTotalDays(leave)} day(s) · {fmtDate(getFromDate(leave))} → {fmtDate(getToDate(leave))}
              </span>
            </div>
            <div className="flex justify-between text-[12px]">
              <span className="text-emerald-700 font-semibold">Reason</span>
              <span className="text-emerald-900 text-right max-w-[60%]">{getReason(leave) || '—'}</span>
            </div>
          </div>

          {error && (
            <div className="text-[12px] text-red-600 bg-red-50 px-3 py-2 rounded-lg border border-red-200 flex gap-1.5 items-center">
              <AlertCircle size={12} />{error}
            </div>
          )}

          <div>
            <label className={LBL}>Approval Note (optional)</label>
            <input className={INP} placeholder="Reason / remarks"
              value={reason} onChange={e => setReason(e.target.value)} />
          </div>
        </div>
        <div className="flex gap-2 px-5 py-4 border-t border-gray-200 bg-gray-50 rounded-b-2xl">
          <button onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-600 border border-gray-200 rounded-xl hover:bg-gray-100">
            Cancel
          </button>
          <button onClick={handleApprove} disabled={loading}
            className="flex-1 flex items-center justify-center gap-1.5 py-2 text-sm font-bold text-white bg-emerald-500 hover:bg-emerald-600 rounded-xl disabled:opacity-60">
            {loading ? <><Loader2 size={13} className="animate-spin" />Approving...</> : <><CheckCircle size={13} />Confirm Approve</>}
          </button>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════
// Main Page
// ═══════════════════════════════════════════════════════════════════════════
export default function LeaveManagement() {
  const dispatch = useDispatch();
  const { employees } = useSelector(s => s.employees);
  const dropdowns = useSelector(s => s.dropdowns || {});
  // TODO: point this at wherever your logged-in user id actually lives
  const currentUserId = useSelector(s => s.auth?.user?.userId || s.auth?.user?.UserId || '');

  useEffect(() => {
    if (!dropdowns.loaded && !dropdowns.loading) {
      dispatch(fetchAllDropdowns());
    }
  }, [dispatch, dropdowns.loaded, dropdowns.loading]);

  // ── Leave type id -> name map, loaded once from LeaveService.GetLeaveTypeList ──
  const [leaveTypeMap, setLeaveTypeMap] = useState({});
  useEffect(() => {
    let cancelled = false;
    LeaveService.GetLeaveTypeList()
      .then(res => {
        const rows = res?.data?.ResultSet || res?.data?.resultSet || [];
        const map = {};
        rows.forEach(r => {
          const id = r.TYPE_ID ?? r.TypeId ?? r.typeId ?? r.p_typeId;
          const name = r.TYPE_NAME ?? r.TypeName ?? r.typeName ?? r.p_typeName;
          if (id != null) map[String(id)] = name;
        });
        if (!cancelled) setLeaveTypeMap(map);
      })
      .catch(() => { /* leave type names are cosmetic — fail silently */ });
    return () => { cancelled = true; };
  }, []);

  const [tab, setTab] = useState('pending');
  const [leaves, setLeaves] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [toast, setToast] = useState('');
  const [searchSno, setSearchSno] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);
  const [viewLeave, setViewLeave] = useState(null);
  const [approveLeave, setApproveLeave] = useState(null);

  const showToast = useCallback((msg) => {
    setToast(msg);
    setTimeout(() => setToast(''), 3500);
  }, []);

  // ── All data now flows through leaveActions.js -> LeaveService.js ─────────
  const runFetch = useCallback((thunk, { search = false } = {}) => {
    (search ? setSearchLoading : setLoading)(true);
    setError('');
    dispatch(thunk)
      .unwrap()
      .then(data => setLeaves(Array.isArray(data) ? data : []))
      .catch(e => setError(typeof e === 'string' ? e : (e?.message || 'Failed to load leaves')))
      .finally(() => (search ? setSearchLoading : setLoading)(false));
  }, [dispatch]);

  const fetchByTab = useCallback((t) => {
    if (t === 'pending')  return runFetch(fetchLeaveRequestsByStatus(PENDING_LEAVE_STATUS));
    if (t === 'approved') return runFetch(fetchLeaveRequestsByStatus(APPROVED_LEAVE_STATUS));
    if (t === 'rejected') return runFetch(fetchLeaveRequestsByStatus(REJECT_LEAVE_STATUS));
    if (t === 'canceled') return runFetch(fetchLeaveRequestsByStatus(CANCEL_LEAVE_STATUS));
  }, [runFetch]);

  const fetchByEmployee = useCallback((sno) => {
    if (!sno) return;
    runFetch(fetchLeaveDetailsByUser(sno), { search: true });
  }, [runFetch]);

  useEffect(() => {
    if (tab !== 'search') fetchByTab(tab);
  }, [tab, fetchByTab]);

  useEffect(() => {
    if (tab === 'search' && searchSno) fetchByEmployee(searchSno);
  }, [tab, searchSno, fetchByEmployee]);

  const stats = useMemo(() => ({
    total:    leaves.length,
    pending:  leaves.filter(isPendingLeave).length,
    approved: leaves.filter(l => getStatus(l).toUpperCase() === 'APPROVED').length,
  }), [leaves]);

  const TABS = [
    { id: 'pending',  label: 'Pending' },
    { id: 'approved', label: 'Approved' },
    { id: 'rejected', label: 'Rejected' },
    { id: 'canceled', label: 'Canceled' },
  ];

  return (
    <div className="flex flex-col h-full bg-gray-50 overflow-hidden">
      {toast && (
        <div className="fixed top-4 right-4 z-[100] flex items-center gap-2 px-4 py-3 bg-emerald-500 text-white rounded-xl shadow-lg text-sm font-medium">
          <CheckCircle size={15} />{toast}
        </div>
      )}

      {/* Header */}
      <div className="bg-white border-b border-gray-200 px-6 py-4 shrink-0">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-gradient-to-br from-primary-500 to-primary-600 rounded-xl flex items-center justify-center shadow-sm">
              <Calendar size={18} className="text-white" />
            </div>
            <div>
              <h1 className="text-base font-bold text-gray-900">Leave Management</h1>
              <p className="text-[11px] text-gray-500">
                {leaves.length > 0 ? `${leaves.length} records loaded` : 'eHRM Leave Management'}
              </p>
            </div>
          </div>
        </div>

        {/* Tabs */}
        <div className="flex gap-1 mt-4 flex-wrap">
          {TABS.map(t => (
            <button key={t.id} onClick={() => setTab(t.id)}
              className={`px-3 py-1.5 rounded-lg text-[12px] font-semibold transition-colors
                ${tab === t.id ? 'bg-primary-500 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>
              {t.label}
            </button>
          ))}
        </div>

        {leaves.length > 0 && (
          <div className="flex gap-3 mt-4 flex-wrap">
            {[
              { label: 'Total',    value: stats.total,    color: 'text-gray-800' },
              { label: 'Pending',  value: stats.pending,  color: 'text-amber-600' },
              { label: 'Approved', value: stats.approved, color: 'text-emerald-600' },
            ].map(({ label, value, color }) => (
              <div key={label} className="bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 flex items-center gap-2">
                <span className={`text-xl font-extrabold ${color}`}>{value}</span>
                <span className="text-[11px] text-gray-500 font-medium">{label}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto px-6 py-5">
        

        {tab !== 'search' && (
          <div className="mb-5 flex justify-end">
            <button onClick={() => fetchByTab(tab)} disabled={loading}
              className="flex items-center gap-1.5 px-3 py-2 border border-gray-200 rounded-xl text-sm text-gray-600 hover:bg-gray-50 transition-colors">
              <RefreshCw size={12} className={loading ? 'animate-spin' : ''} /> Refresh
            </button>
          </div>
        )}

        {error && (
          <div className="flex items-center gap-2 px-4 py-3 bg-red-50 border border-red-200 rounded-xl text-red-700 text-sm mb-4">
            <AlertCircle size={14} />{error}
            <button onClick={() => setError('')} className="ml-auto"><X size={13} /></button>
          </div>
        )}

        {(loading || searchLoading) && (
          <div className="flex items-center justify-center py-16 gap-3 text-gray-400">
            <Loader2 size={22} className="animate-spin text-primary-500" />
            <span className="text-sm">Loading leaves...</span>
          </div>
        )}

        {!loading && !searchLoading && leaves.length === 0 && !error && (
          <div className="flex flex-col items-center justify-center py-16 gap-3 text-gray-400">
            <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center">
              <Calendar size={28} className="opacity-40" />
            </div>
            <p className="text-sm font-semibold text-gray-500">
              {tab === 'search' && !searchSno ? 'Select an employee above to load leaves' : 'No leave requests found'}
            </p>
          </div>
        )}

        {!loading && !searchLoading && leaves.length > 0 && (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {leaves.map((leave, i) => (
              <LeaveCard
                key={getFormId(leave) || getFormNo(leave) || i}
                leave={leave}
                leaveTypeMap={leaveTypeMap}
                onView={setViewLeave}
                onApprove={setApproveLeave}
                showApprove
              />
            ))}
          </div>
        )}
      </div>

      {viewLeave && (
        <ViewLeaveModal
          leave={viewLeave}
          leaveTypeMap={leaveTypeMap}
          onClose={() => setViewLeave(null)}
          onApprove={(l) => { setViewLeave(null); setApproveLeave(l); }}
        />
      )}
      {approveLeave && (
        <ApproveModal
          leave={approveLeave}
          currentUserId={currentUserId}
          onClose={() => setApproveLeave(null)}
          onSuccess={(msg) => {
            showToast(msg);
            tab === 'search' && searchSno ? fetchByEmployee(searchSno) : fetchByTab(tab);
          }}
        />
      )}
    </div>
  );
}